import { Tooltip, TooltipProps } from "@chakra-ui/react";
import React from "react";

const BASIC_TOOLTIP_DEFAULTS = {
  placement: "top" as const,
  hasArrow: true,
  bg: "#505863",
  color: "white",
  borderRadius: "3px",
  px: "8px",
  py: "6px",
  fontSize: "14px",
  fontWeight: "600",
  lineHeight: "20px",
};

type BasicTooltipProps = TooltipProps;

/**
 * BrightHire-styled tooltip for simple label tooltips. Uses dark gray background,
 * rounded corners, arrow, and consistent padding. Wraps Chakra's Tooltip with
 * standard BH design defaults.
 */
export const BasicTooltip: React.FC<BasicTooltipProps> = (props) => (
  <Tooltip {...BASIC_TOOLTIP_DEFAULTS} {...props} />
);
